export const FILTER_PHONE_OFFER = "filterPhoneOffer";
export const FILTER_PROPOSITION = "filterProposition";
export const FILTER_SIM_ONLY = "filterSimOnly";
export const OFFER_TYPE = "offerType";
export const PORTAL = "portal";
export const SORT_PHONE_OFFER = "sortPhoneOffer";
export const SORT_PROPOSITION = "sortProposition";
export const SORT_SIM_ONLY = "sortSimOnly";
